(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const formId = '{{ form_id }}';
    const fileInput = document.getElementById(formId + '-fotos');
    const preview = document.getElementById(formId + '-preview');
    const countDisplay = document.getElementById(formId + '-count');
    const maxFiles = 5;

    if (!fileInput || !preview || !countDisplay) return;

    function updatePreviewAndCount() {
      preview.innerHTML = '';
      const files = Array.from(fileInput.files);
      countDisplay.textContent = `${files.length} / ${maxFiles} fotos selecionadas`;

      files.forEach((file, index) => {
        if (file.type.match('image.*')) {
          const reader = new FileReader();
          reader.onload = function (e) {
            const wrapper = document.createElement('div');
            wrapper.style.position = 'relative';
            wrapper.style.display = 'inline-block';
            wrapper.style.cursor = 'pointer';

            const img = document.createElement('img');
            img.src = e.target.result;
            img.style.width = '120px';
            img.style.height = '120px';
            img.style.objectFit = 'cover';
            img.style.borderRadius = '8px';
            img.style.border = '3px solid #0BA782';
            img.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            img.style.transition = 'transform 0.2s ease';

            // Hover effect
            wrapper.onmouseover = () => img.style.transform = 'scale(1.05)';
            wrapper.onmouseout = () => img.style.transform = 'scale(1)';

            // Clique na imagem remove
            wrapper.onclick = function (e) {
              e.preventDefault();
              const dt = new DataTransfer();
              Array.from(fileInput.files).forEach((f, i) => {
                if (i !== index) dt.items.add(f);
              });
              fileInput.files = dt.files;
              updatePreviewAndCount();
            };

            wrapper.appendChild(img);
            preview.appendChild(wrapper);
          };
          reader.readAsDataURL(file);
        }
      });
    }

    fileInput.addEventListener('change', function () {
      let files = Array.from(fileInput.files);

      if (files.length > maxFiles) {
        alert(`Só pode selecionar no máximo ${maxFiles} fotos. As primeiras ${maxFiles} serão mantidas.`);
        files = files.slice(0, maxFiles);
        const dt = new DataTransfer();
        files.forEach(file => dt.items.add(file));
        fileInput.files = dt.files;
      }

      updatePreviewAndCount();
    });

    // Inicializa (caso haja algo)
    updatePreviewAndCount();
  });
  } catch(e) { console.error(e); }
})();

})();
